import { Injectable } from '@angular/core'
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest, HttpResponse, HttpErrorResponse } from '@angular/common/http';
import { Router } from '@angular/router';
import { Observable, empty, throwError } from 'rxjs';
import { catchError, retry, map, tap } from 'rxjs/operators';

import { CookieService } from 'ngx-cookie-service';
import { AuthService } from './auth.service';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {

  constructor(public router: Router, private authService: AuthService) { }
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    const authToken = this.authService.getAuthToken();
    req = req.clone({
      setHeaders: {
        Authorization: 'Bearer ' + authToken
      }
    });

    return next.handle(req).pipe(
      map((event: HttpEvent<any>) => { 
        if (event instanceof HttpResponse) {
        }
        return event; 
      }),
      retry(0),
      catchError((error: HttpErrorResponse) => {
        if (error.status === 401) {
          console.log('Not Authenticated');
          var currentClient: any = localStorage.getItem('selectedClient');
          localStorage.clear();
          localStorage.setItem('selectedClient', currentClient);
          this.router.navigate(['/login']);    
        }
        return throwError(error);
      }));
  }
}
